/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { CircularProgress } from "@material-ui/core"
import { getRequest } from "utils/request"
import { useHistory } from "react-router-dom"

import TabCompany from "./TabCompany"
import TabHours from "./TabHours"
import TabConfig from "./TabConfig"
import TabStatus from "./TabStatus"
import TabSLA from "./TabSLA"
import TabBotConfig from "./TabBotConfig"
import TabHolliday from "./TabHolliday"
import TabDistribution from "./TabDistribution"
import TabChannels from "./TabChannels"
import TabUserType from "./TabUserType"
import TabTicketType from "./TabTicketType"
import TabShortcut from "./TabShortcut"
import TabAdministration from "./TabAdministration"
import TabDepartments from "./TabDepartments"
import TabRememberClient from "./TabRememberClient"

import "./style.css"

import { i18n } from "../../translate/i18n"
import { useModal } from "hooks/modal"
import { useAuth } from "hooks/auth"
import { toast } from "react-toastify"
import Swal from "sweetalert2"
import { useNotification } from "hooks/notification"
import { putRequest } from "utils/request"

export default function EditCompany({ match }) {
  const [companyData, setCompanyData] = useState({})
  const [loading, setLoading] = useState(true)
  const [update, setUpdate] = useState(0)
  const [updateSla, setUpdateSla] = useState(0)
  const [tab, setTab] = useState(1)
  const [listSLA, setListSLA] = useState([])
  const history = useHistory()
  const { user } = useAuth()
  const { toggleHelperId } = useModal()
  const { listOptionsCompanies, selectedCompany, addSelectedCompany } =
    useNotification()

  const loadCompanyData = async () => {
    setLoading(true)
    const companyId = match.params.id

    getRequest(`/companies/admin/${companyId}`).then(function (response) {
      if (response.data) {
        setCompanyData(response.data)
      }
      setLoading(false)
    })
  }

  const loadSla = async () => {
    const companyId = match.params.id

    const ReturnGet = await getRequest(
      `/companiesticketsyslas?CompanyId=${companyId}`
    )
    if (ReturnGet.success) {
      setListSLA(ReturnGet.data)
    }
  }

  const getPermission = async () => {
    getRequest(
      `/menus/editAllowed?UserTypeId=${user.UserTypeId}&CompanyId=${match.params.id}&User=${user.id}`
    ).then((e) => {
      if (e.success) {
        if (e.data.data === false) {
          history.push("/dashboard")
          toast.info(i18n.t("noPermission"))
        }
      }
    })
  }

  useEffect(() => {
    getPermission()
    if (user.UserTypeId === 13) {
      setTab(16)
    }
  }, [])

  useEffect(() => {
    loadCompanyData()
  }, [update])

  useEffect(() => {
    loadSla()
  }, [updateSla])

  const handleUpdateSla = () => {
    setUpdateSla(updateSla + 1)
  }

  const handleUpdate = (tab) => {
    setTab(tab)
    setUpdate(update + 1)
  }

  const handleInativate = (id) => {
    Swal.fire({
      title: i18n.t("attemption"),
      text: i18n.t("eraseCompany"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: i18n.t("confirmEraseCompany"),
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: i18n.t("attemption"),
          text: i18n.t("putExclude"),
          icon: "warning",
          input: "text",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: i18n.t("confirm"),
          preConfirm: (value) => {
            if (value.toUpperCase() !== "EXCLUIR") {
              Swal.showValidationMessage(
                `Você digitou excluir de forma incorreta`
              )
            }
          },
        }).then(async (result) => {
          //INATIVAR EMPRESA
          if (result.isConfirmed) {
            const ReturnPut = await putRequest(`/companies/inactivate/${id}`)
            if (ReturnPut.success) {
              if (
                id === selectedCompany.id &&
                listOptionsCompanies[0].value !== 0
              ) {
                addSelectedCompany({
                  value: listOptionsCompanies[0].value,
                  trial: listOptionsCompanies[0].trial,
                  id: listOptionsCompanies[0].value,
                  label: listOptionsCompanies[0].nickName,
                  logo: listOptionsCompanies[0].pathLogo,
                  trialLimit: listOptionsCompanies[0].trialValidate,
                  usersLimit: listOptionsCompanies[0].usersLimit,
                  dueDay: listOptionsCompanies[0].dueDay,
                  ticketToShow: listOptionsCompanies[0].ticketShowData,
                })
              } else {
                addSelectedCompany({
                  value: listOptionsCompanies[0].value,
                  trial: null,
                  id: listOptionsCompanies[0].value,
                  label: listOptionsCompanies[0].label,
                  logo: listOptionsCompanies[0].pathLogo,
                  trialLimit: null,
                  usersLimit: null,
                  dueDay: null,
                  ticketToShow: null,
                })
              }
              history.push("/dashboard")
            }
          }
        })
      }
    })
  }

  useEffect(() => {
    toggleHelperId(28)
  }, [loading])

  return (
    <>
      {!loading ? (
        <>
          <div className="container-edit-company-page">
            <div
              className="row"
              style={{ display: "flex", width: "98vw", position: "relative" }}
            >
              <div className="col-sm-2 mb-2 mb-sm-0">
                <ul
                  className="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                  style={{ position: "relative" }}
                >
                  {user.UserTypeId !== 13 && (
                    <>
                      <li className="nav-item">
                        <a
                          href="#company"
                          onClick={() => toggleHelperId(28)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 1
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0 "
                          }
                        >
                          <i className="mdi mdi-home-variant d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("company")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#calls"
                          onClick={() => toggleHelperId(30)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 2
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("callsDistribution")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#attendance"
                          onClick={() => toggleHelperId(33)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 3
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-account-circle d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("openingHour")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#configuration"
                          onClick={() => toggleHelperId(29)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 4
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("apparence")}
                          </span>
                        </a>
                      </li>

                      <li className="nav-item">
                        <a
                          href="#Status"
                          onClick={() => toggleHelperId(40)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 5
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("status")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#SLA"
                          onClick={() => toggleHelperId(38)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 6
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">SLA</span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#holliday"
                          onClick={() => toggleHelperId(31)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 8
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-account-circle d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("holliday")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          onClick={() => toggleHelperId(35)}
                          href="#channels"
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 10
                              ? "nav-link rounded-0 active "
                              : `nav-link rounded-0`
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("channel")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#usertype"
                          onClick={() => toggleHelperId(45)}
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 11
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("clientsTypes")}
                          </span>
                        </a>
                      </li>
                      {!companyData.openIntegration && (
                        <li className="nav-item">
                          <a
                            href="#tickettype"
                            data-toggle="tab"
                            onClick={() => toggleHelperId(42)}
                            aria-expanded="false"
                            className={
                              tab === 12
                                ? "nav-link rounded-0 active"
                                : "nav-link rounded-0"
                            }
                          >
                            <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                            <span className="d-none d-md-block">
                              {i18n.t("ticketType")}
                            </span>
                          </a>
                        </li>
                      )}
                      <li className="nav-item">
                        <a
                          href="#departments"
                          data-toggle="tab"
                          onClick={() => toggleHelperId(47)}
                          aria-expanded="false"
                          className={
                            tab === 13
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("departments")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#shortcut"
                          data-toggle="tab"
                          onClick={() => toggleHelperId(36)}
                          aria-expanded="false"
                          className={
                            tab === 14
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("attendanceShortcut")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#rememberClient"
                          data-toggle="tab"
                          onClick={() => toggleHelperId(48)}
                          aria-expanded="false"
                          className={
                            tab === 17
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">
                            {i18n.t("rememberClient")}
                          </span>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#botconfig"
                          data-toggle="tab"
                          aria-expanded="false"
                          className={
                            tab === 15
                              ? "nav-link rounded-0 active"
                              : "nav-link rounded-0"
                          }
                        >
                          <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                          <span className="d-none d-md-block">Bot</span>
                        </a>
                      </li>
                    </>
                  )}
                  {(user.UserTypeId === 1 ||
                    user.UserTypeId === 2 ||
                    user.UserTypeId === 13) && (
                    <li className="nav-item">
                      <a
                        href="#administrative"
                        data-toggle="tab"
                        aria-expanded="false"
                        className={
                          tab === 16
                            ? "nav-link rounded-0 active"
                            : "nav-link rounded-0"
                        }
                      >
                        <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                        <span className="d-none d-md-block">
                          {i18n.t("administration")}
                        </span>
                      </a>
                    </li>
                  )}
                  <li className="nav-item">
                    <div
                      className="get-back"
                      onClick={() => history.push("/dashboard/company")}
                    >
                      {i18n.t("getBack")}
                    </div>
                  </li>
                  <div
                    className="delete-company"
                    onClick={() => handleInativate(selectedCompany.id)}
                  >
                    {i18n.t("deleteCompany")}
                  </div>
                </ul>
              </div>
              <div className="col-sm-10">
                <div className="tab-content" style={{ marginBottom: 50 }}>
                  <div
                    className={
                      tab === 1 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="company"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                      style={{ marginBottom: 20 }}
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabCompany
                            updateSla={handleUpdateSla}
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 3 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="attendance"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabHours
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 8 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="holliday"
                  >
                    <div className="container-card">
                      <div className="col-lg-12">
                        <TabHolliday
                          companyData={companyData}
                          handleUpdate={handleUpdate}
                        />
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      tab === 4 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="configuration"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabConfig
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      tab === 5 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="Status"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabStatus
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      tab === 6 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="SLA"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                      style={{ marginBottom: 20 }}
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabSLA
                            companyData={companyData}
                            listSLA={listSLA}
                            handleUpdateSla={handleUpdateSla}
                            handleUpdate={handleUpdate}
                            match={match}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 2 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="calls"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabDistribution
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      tab === 10 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="channels"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabChannels
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={
                      tab === 11 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="usertype"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabUserType
                            match={match}
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 12 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="tickettype"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabTicketType
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 13 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="departments"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabDepartments
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 14 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="shortcut"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div
                          className="col-lg-12"
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                          }}
                        >
                          <TabShortcut
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 17 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="rememberClient"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabRememberClient
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 15 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="botconfig"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabBotConfig
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                            update={update}
                            match={match}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      tab === 16 ? "tab-pane show active" : "tab-pane show"
                    }
                    id="administrative"
                  >
                    <div
                      className={
                        tab === 1 ? "tab-pane show active" : "tab-pane show"
                      }
                      id="input-types-preview"
                    >
                      <div className="container-card">
                        <div className="col-lg-12">
                          <TabAdministration
                            companyData={companyData}
                            handleUpdate={handleUpdate}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <div className="area-loading-edit-company">
          <CircularProgress />
        </div>
      )}
    </>
  )
}
